import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CountdownType } from '../../../../otp-count-down/otp-count-down.component';
import { DialogMessageType } from '../../../../../../shared/models/utility.model';

@Component({
    selector: 'app-kamona-maximize-mobile-dialog',
    templateUrl: './kamona-maximize-mobile-dialog.component.html',
    styleUrls: ['./kamona-maximize-mobile-dialog.component.scss'],
})
export class KamonaMaximizeMobileDialogComponent implements OnInit {
    readonly MESSAGE_TYPE = DialogMessageType;
    @Input() mobileMessageType: DialogMessageType;
    @Output() emitAction = new EventEmitter();
    @Output() emitSecondaryAction = new EventEmitter();
    @Input() title: string;
    @Input() extraMessage?: string;
    readonly PROCEED = 1;
    readonly CANCEL = 0;
    @Input() description: string;
    @Input() useFailureSecondaryButton: Boolean;
    @Input() buttonName = 'Continue';
    @Input() secondaryButtonName = 'Action';
    @Input() otpSuspensionExpiryTime: any;
    countdownType: CountdownType = CountdownType.OTP_SUSPENSION;
    @Input() loading: boolean;
    enableSuspensionRetryButton: boolean;

    constructor() {}

    ngOnInit(): void {}

    continue() {
        if (!this.loading) {
            this.emitAction.emit(this.PROCEED);
        }
    }

    enableRetryButton($event: any) {
        this.enableSuspensionRetryButton = $event;
    }

    retryOTP() {
        this.emitAction.emit();
    }
}
